<div [class]="mainClasses">

  <div class="border-bottom p-1">
    <div class="row">
      <div class="col-2">
        <app-button text="{{'LEFT'|translate}}" icon="chevron-left" hideText="true" (click)="onClickNavigate(true)">
        </app-button>
      </div>
      <div class="col-8 text-center">
        <h5 class="m-0" style="line-height: 2.375rem">{{currentDate|eventoDay}}, {{currentDate|eventoDate}}</h5>
      </div>
      <div class="col-2 text-right">
        <app-button text="{{'RIGHT'|translate}}" icon="chevron-right" hideText="true" (click)="onClickNavigate(false)">
        </app-button>
      </div>
    </div>
  </div>

  <!-- loading spinner -->
  <div *ngIf="isLoading" class="text-center m-3">
    <app-spinner size="l" dark="true"></app-spinner>
    <p>{{'LOADING'|translate}}</p>
  </div>

  <ng-container *ngIf="!isLoading">

    <div *ngIf="!hasResults" class="alert alert-info mt-1">{{emptyResultMessage}}</div>

    <!-- DESKTOP  -->
    <app-room-allocation-desktop *ngIf="!isMobileView && hasResults" [model]="allocationTable" [baseDate]="currentDate"
      (openRoomInfo)="onOpenRoomInfo($event)" (openSchedule)="onOpenSchedule($event)"
      (createReservation)="onCreateReservation($event)" [openResourceInfoText]="openResourceInfoText"
      [openResourceCalendarText]="openResourceCalendarText" (timelineReservationConflicted)="alertConflict($event)">
    </app-room-allocation-desktop>

    <!-- MOBILE -->
    <ng-container *ngIf="isMobileView && hasResults">
      <ng-container *ngFor="let item of allocationTable.displayItems; let i = index">
        <app-room-allocation-mobile [item]="item" [baseDate]="currentDate" [type]="type"
          (createReservation)="onCreateReservation($event)" (openRoomInfo)="onOpenRoomInfo($event)"
          (openSchedule)="onOpenSchedule($event)" [bgLight]="showBgLight(i)" [useReservationMode]="useReservationMode"
          [useColumnsDataAsCaption]="useColumnsDataAsCaption" [openResourceInfoText]="openResourceInfoText"
          [openResourceCalendarText]="openResourceCalendarText">
        </app-room-allocation-mobile>
      </ng-container>
    </ng-container>

  </ng-container>

</div>

<!-- Info Dialog -->
<app-modal-dialog #roomInfoDialog title="{{modalRoomInfoTitle}}" [body]="modalRoomInfo" [showPositive]="false"
  cancelButton="{{'CLOSE'|translate}}"></app-modal-dialog>
<ng-template #modalRoomInfo>
  <ng-container [ngSwitch]="type">
    <app-room-info *ngSwitchCase="2" [roomId]="activeItemId"></app-room-info>
    <app-device-info *ngSwitchCase="3" [deviceId]="activeItemId"></app-device-info>
    <!--default case when there are no matches -->
    <div *ngSwitchDefault>Unknown type '{{type}}'</div>
  </ng-container>
</ng-template>

<app-modal-dialog #occupancyAlertModal title="{{'NICHT_ERLAUBT'|translate}}" [showCancel]="false"
  positiveButton="{{'CLOSE'|translate}}" [body]="modalBodyAlert" backdrop="static" size="sm">
</app-modal-dialog>
<ng-template #modalBodyAlert>
  <p>{{timespanConflictMessageKey|translate}}</p>
</ng-template>